import {StyleSheet} from 'react-native';
import {colors} from '../../constants';
import {MATERIAL_ICONS_FONT} from '../../styles/fonts';

const fc = colors.frame; // Frame colors shorthand

export const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: fc.background,
  },
  loadingContainer: {
    justifyContent: 'center',
    alignItems: 'center',
  },

  // Photo Background
  photoContainer: {
    ...StyleSheet.absoluteFillObject,
    overflow: 'hidden',
  },
  photo: {
    // Size is set dynamically based on scaled dimensions
  },
  gradientTop: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    height: '30%',
    background: 'linear-gradient(to bottom, rgba(28, 25, 23, 0.3), transparent)',
  } as any,
  gradientBottom: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    height: '50%',
    background: 'linear-gradient(to top, rgba(28, 25, 23, 0.9), transparent)',
  } as any,

  // Settings Button
  settingsButton: {
    position: 'absolute',
    top: 24,
    right: 24,
    width: 48,
    height: 48,
    borderRadius: 24,
    backgroundColor: 'rgba(41, 37, 36, 0.6)',
    backdropFilter: 'blur(12px)',
    justifyContent: 'center',
    alignItems: 'center',
    borderWidth: 1,
    borderColor: fc.border,
    zIndex: 100,
  } as any,
  settingsIcon: {
    fontFamily: MATERIAL_ICONS_FONT,
    fontSize: 24,
    color: fc.text,
  },

  // Display name label
  displayNameLabel: {
    position: 'absolute',
    top: 24,
    left: 24,
    backgroundColor: 'rgba(41, 37, 36, 0.6)',
    backdropFilter: 'blur(12px)',
    paddingVertical: 10,
    paddingHorizontal: 16,
    borderRadius: 20,
    borderWidth: 1,
    borderColor: fc.border,
    zIndex: 100,
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
  } as any,
  displayNameIcon: {
    fontFamily: MATERIAL_ICONS_FONT,
    fontSize: 18,
    color: fc.primary,
  },
  displayNameText: {
    fontSize: 14,
    fontWeight: '600',
    color: fc.text,
  },

  // Reposition Button
  repositionButton: {
    position: 'absolute',
    top: 24,
    right: 80,
    width: 48,
    height: 48,
    borderRadius: 24,
    backgroundColor: 'rgba(41, 37, 36, 0.6)',
    backdropFilter: 'blur(12px)',
    justifyContent: 'center',
    alignItems: 'center',
    borderWidth: 1,
    borderColor: fc.border,
    zIndex: 100,
  } as any,

  // Loading progress bar
  loadingProgressContainer: {
    position: 'absolute',
    top: 24,
    left: 24,
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
    backgroundColor: 'rgba(41, 37, 36, 0.6)',
    backdropFilter: 'blur(12px)',
    paddingVertical: 8,
    paddingHorizontal: 12,
    borderRadius: 16,
    borderWidth: 1,
    borderColor: fc.border,
    zIndex: 50,
  } as any,
  loadingProgressBar: {
    width: 60,
    height: 4,
    backgroundColor: 'rgba(255, 255, 255, 0.2)',
    borderRadius: 2,
    overflow: 'hidden',
  },
  loadingProgressFill: {
    height: '100%',
    backgroundColor: fc.primary,
    borderRadius: 2,
  },
  loadingProgressText: {
    fontSize: 12,
    color: fc.textMuted,
    fontVariant: ['tabular-nums'],
  },

  // Edit mode gesture overlay - captures pan gestures
  editModeGestureOverlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 80,
  },
  editModeBorder: {
    position: 'absolute',
    top: 8,
    left: 8,
    right: 8,
    bottom: 8,
    borderWidth: 3,
    borderColor: fc.primary,
    borderRadius: 16,
    borderStyle: 'dashed',
  } as any,
  editModeHeader: {
    position: 'absolute',
    top: 24,
    left: 0,
    right: 0,
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: 'center',
    gap: 12,
  },
  editModeText: {
    backgroundColor: 'rgba(41, 37, 36, 0.9)',
    paddingVertical: 10,
    paddingHorizontal: 20,
    borderRadius: 20,
    fontSize: 16,
    fontWeight: '600',
    color: fc.text,
    overflow: 'hidden',
  },
  editModeSaving: {
    backgroundColor: 'rgba(41, 37, 36, 0.9)',
    paddingVertical: 8,
    paddingHorizontal: 16,
    borderRadius: 16,
    fontSize: 14,
    color: fc.textMuted,
    overflow: 'hidden',
  },
  editModeSaved: {
    backgroundColor: 'rgba(34, 197, 94, 0.9)',
    paddingVertical: 8,
    paddingHorizontal: 16,
    borderRadius: 16,
    fontSize: 14,
    fontWeight: '600',
    color: '#fff',
    overflow: 'hidden',
  },
  editModeFooter: {
    position: 'absolute',
    bottom: 24,
    left: 0,
    right: 0,
    alignItems: 'center',
  },
  editModeDoneButton: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
    paddingVertical: 14,
    paddingHorizontal: 28,
    borderRadius: 28,
    backgroundColor: fc.primary,
  },
  editModeDoneIcon: {
    fontFamily: MATERIAL_ICONS_FONT,
    fontSize: 24,
    color: '#1c1917',
  },
  editModeDoneText: {
    fontSize: 16,
    fontWeight: '600',
    color: '#1c1917',
  },

  // First-time hint
  hintOverlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    zIndex: 90,
  },
  hintContainer: {
    position: 'absolute',
    top: 16,
    right: 16,
    alignItems: 'flex-end',
  },
  hintArrow: {
    marginRight: 8,
    marginBottom: 4,
  },
  hintArrowIcon: {
    fontFamily: MATERIAL_ICONS_FONT,
    fontSize: 32,
    color: fc.primary,
  },
  hintBubble: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 12,
    backgroundColor: 'rgba(41, 37, 36, 0.95)',
    paddingVertical: 16,
    paddingHorizontal: 20,
    borderRadius: 16,
    borderWidth: 1,
    borderColor: fc.border,
    backdropFilter: 'blur(10px)',
    maxWidth: 300,
  } as any,
  hintIcon: {
    fontFamily: MATERIAL_ICONS_FONT,
    fontSize: 28,
    color: fc.primary,
  },
  hintContent: {
    flex: 1,
  },
  hintText: {
    fontSize: 16,
    fontWeight: '600',
    color: fc.text,
  },
  hintSubtext: {
    fontSize: 13,
    color: fc.textMuted,
    marginTop: 2,
  },
  hintButton: {
    marginTop: 12,
    backgroundColor: fc.primary,
    paddingVertical: 12,
    paddingHorizontal: 24,
    borderRadius: 12,
    alignSelf: 'stretch',
  },
  hintButtonText: {
    fontSize: 16,
    fontWeight: '600',
    color: '#1c1917',
    textAlign: 'center',
  },

  // Main Info - Bottom Left
  mainInfo: {
    position: 'absolute',
    bottom: 40,
    left: 40,
    zIndex: 20,
  },
  greeting: {
    fontSize: 32,
    fontWeight: '700',
    color: fc.greeting,
    marginBottom: 8,
    textShadowColor: 'rgba(0,0,0,0.5)',
    textShadowOffset: {width: 0, height: 2},
    textShadowRadius: 8,
  },
  timeRow: {
    flexDirection: 'row',
    alignItems: 'baseline',
    gap: 16,
  },
  time: {
    fontSize: 80,
    fontWeight: '700',
    color: fc.primary,
    lineHeight: 80,
    textShadowColor: 'rgba(0,0,0,0.3)',
    textShadowOffset: {width: 0, height: 2},
    textShadowRadius: 4,
  },
  date: {
    fontSize: 28,
    fontWeight: '500',
    color: fc.text,
    opacity: 0.9,
  },

  // Reminders Panel - Bottom Right
  remindersPanel: {
    position: 'absolute',
    bottom: 40,
    right: 40,
    width: 380,
    maxHeight: 400,
    backgroundColor: fc.surface,
    backdropFilter: 'blur(24px)',
    borderRadius: 24,
    padding: 20,
    borderWidth: 1,
    borderColor: fc.border,
    zIndex: 20,
  } as any,

  // Panel Header
  reminderHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 16,
  },
  reminderHeaderLeft: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
  },
  reminderIconBg: {
    backgroundColor: 'rgba(255, 158, 128, 0.2)',
    padding: 6,
    borderRadius: 8,
  },
  reminderHeaderIcon: {
    fontFamily: MATERIAL_ICONS_FONT,
    fontSize: 20,
    color: fc.primary,
  },
  reminderHeaderTitle: {
    fontSize: 20,
    fontWeight: '700',
    color: fc.text,
  },

  // Reminders List
  remindersList: {
    flex: 1,
  },
  remindersListContent: {
    gap: 12,
  },

  // Reminder Item
  reminderItem: {
    flexDirection: 'row',
    backgroundColor: 'rgba(68, 64, 60, 0.4)',
    borderRadius: 12,
    padding: 12,
    borderWidth: 1,
    borderColor: 'rgba(68, 64, 60, 0.3)',
  },
  reminderItemToday: {
    backgroundColor: 'rgba(255, 158, 128, 0.1)',
    borderLeftWidth: 6,
    borderLeftColor: fc.primary,
    borderTopLeftRadius: 0,
    borderBottomLeftRadius: 0,
  },

  // Date Section
  reminderDateSection: {
    minWidth: 70,
    paddingRight: 12,
    borderRightWidth: 1,
    borderRightColor: 'rgba(68, 64, 60, 0.3)',
    justifyContent: 'center',
  },
  reminderDateSectionToday: {
    borderRightColor: 'rgba(255, 158, 128, 0.2)',
  },
  reminderDateLabel: {
    fontSize: 12,
    fontWeight: '700',
    color: fc.text,
    textTransform: 'uppercase',
  },
  reminderDateLabelToday: {
    color: fc.primary,
  },
  reminderTime: {
    fontSize: 11,
    color: fc.textMuted,
    marginTop: 2,
  },

  // Content Section
  reminderContent: {
    flex: 1,
    paddingLeft: 12,
    justifyContent: 'center',
  },
  reminderTitle: {
    fontSize: 16,
    fontWeight: '500',
    color: fc.text,
  },
  reminderTitleToday: {
    fontSize: 18,
    fontWeight: '600',
  },
  reminderMeta: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 6,
    marginTop: 4,
  },
  reminderIcon: {
    fontFamily: MATERIAL_ICONS_FONT,
    fontSize: 14,
    color: fc.textMuted,
  },
  reminderIconToday: {
    color: fc.primary,
  },
  reminderCalendar: {
    fontSize: 12,
    color: fc.textMuted,
  },

  // ==================
  // Portrait Layout
  // ==================
  portraitGradientBottom: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    height: '70%',
    background: 'linear-gradient(to top, rgba(28, 25, 23, 0.95), rgba(28, 25, 23, 0.7) 50%, transparent)',
  } as any,

  portraitOverlay: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    top: 0,
    justifyContent: 'flex-end',
    padding: 20,
    gap: 16,
  },

  // Portrait DateTime Panel
  portraitDateTimePanel: {
    backgroundColor: fc.surface,
    backdropFilter: 'blur(24px)',
    borderRadius: 24,
    padding: 24,
    alignItems: 'center',
    borderWidth: 1,
    borderColor: fc.border,
  } as any,
  portraitGreeting: {
    fontSize: 22,
    fontWeight: '600',
    color: fc.greeting,
    marginBottom: 4,
    textShadowColor: 'rgba(0,0,0,0.3)',
    textShadowOffset: {width: 0, height: 1},
    textShadowRadius: 4,
  },
  portraitTime: {
    fontSize: 56,
    fontWeight: '700',
    color: fc.primary,
    lineHeight: 62,
  },
  portraitDate: {
    fontSize: 20,
    fontWeight: '500',
    color: fc.text,
    opacity: 0.9,
    marginTop: 4,
  },

  // Portrait Reminders Panel
  portraitRemindersPanel: {
    backgroundColor: fc.surface,
    backdropFilter: 'blur(24px)',
    borderRadius: 24,
    padding: 20,
    borderWidth: 1,
    borderColor: fc.border,
    maxHeight: 300,
  } as any,
  portraitRemindersList: {
    flex: 1,
  },
});

export default styles;
